import request from 'lib/request';
import { Response } from 'lib/request/types';

type GeologicIntervalTypeCurvesResultItem = {
  basinName: string;
  geologicInterval: string;
  typeCurveFormation: string;
};

type GeologicIntervalTypeCurvesUnpaginatedResponse = {
  results: GeologicIntervalTypeCurvesResultItem[];
  totalCount: number;
};

export default async function getFilterOptions() {
  const response = await request.post<
    GeologicIntervalTypeCurvesUnpaginatedResponse,
    Response<{ errors: { [key: string]: string[] } }>
  >(
    '/queries/geologic_interval_type_curves',
    {
      query: {
        paginated: false,
      },
    },
    new AbortController()
  );

  if (response.type === 'success') {
    const data = response.data;
    return {
      basins: getDistinctValuesFromResponse(data, 'basinName'),
      geologicIntervals: getDistinctValuesFromResponse(
        data,
        'geologicInterval'
      ),
    };
  } else {
    return {
      basins: [],
      geologicIntervals: [],
    };
  }
}

function getDistinctValuesFromResponse(
  data: GeologicIntervalTypeCurvesUnpaginatedResponse,
  field: 'basinName' | 'geologicInterval'
) {
  const result = new Set<string>();
  data.results.forEach((item: GeologicIntervalTypeCurvesResultItem) => {
    result.add(item[field]);
  });
  return Array.from(result).sort();
}
